var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { DeleteOutlined } from '@ant-design/icons';
import { useMixpanel, useService } from '@tenderd/track-web-utils';
import { Button, Popconfirm, message } from 'antd';
import React, { useState } from 'react';
import { GroupGeofenceAction, useGroupGeofencePageContext, } from '../../../GroupGeofencePage.context';
var DeleteGeoFence = function () {
    var context = useGroupGeofencePageContext();
    var _a = __read(useState(false), 2), loading = _a[0], setLoading = _a[1];
    var service = useService();
    var mixpanel = useMixpanel();
    var onArchiveGeofence = function () {
        setLoading(true);
        service.server
            .deleteGroupGeofence(context.selectedGeofence._id)
            .then(function () {
            message.success('Geofence has been archived successfully.');
            mixpanel.track('Geofence Archived', { extension: 'track' });
            context.setPostGeofenceModal(false);
            context.updateGeofenceData('delete', context.selectedGeofence);
            context.setSelectedGeofence(null);
        })
            .finally(function () {
            setLoading(false);
        });
    };
    if (context.selectedGeofence &&
        context.geofenceAction === GroupGeofenceAction.UpdateGeofence) {
        return (React.createElement(Popconfirm, { title: "Archive Group?", description: "Are you sure you want to archive this group?", onConfirm: onArchiveGeofence, okText: "Yes", cancelText: "No" },
            React.createElement(Button, { type: "text", danger: true, loading: loading },
                "Delete Geofence ",
                React.createElement(DeleteOutlined, null))));
    }
    return React.createElement(React.Fragment, null);
};
export default DeleteGeoFence;
